<template lang="html">
  <payout-form-group
    :label="$t('Сумма')"
    :required="true"
    :has-errors="model.errors.hasErrorsSplit(errorsAttribute)">
    <input-amount name="amount"
                  :filter="filter"
                  :disabled="disabled"
                  :total-label="$t('Всего')"
                  v-model="model.values.amount"
                  :source-account="sourceAccount" @click-avail-balance="onAvailBalanceClick"></input-amount>
    <payout-input-hint-block
      v-slot:hints
      :hint="hint ? hint : model.getHint('amount')"></payout-input-hint-block>
    <error-message-block
      :attribute="errorsAttribute"
      :errors="model.errors"></error-message-block>
  </payout-form-group>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import PayoutFormGroup from '@/components/forms/payout/PayoutFormGroup.vue';
import InputAmount from '@/components/forms/payout/legacy/InputAmount.vue';
import PayoutInputHintBlock from '@/components/forms/payout/PayoutInputHintBlock.vue';
import ErrorMessageBlock from '@/components/forms/payout/ErrorMessageBlock.vue';
import {
  EvaluateReverseFeeResultInterface,
  PayoutTaxRuleInterface,

} from '@/components/forms/payout/payout-basics';
import {PayoutWebModel} from "capitalist-shared/src/finance/payments";

@Component({
  name: 'payout-input-amount-form-group',
  components: {
    ErrorMessageBlock, PayoutInputHintBlock, InputAmount, PayoutFormGroup,
  },
})
export default class PayoutInputAmountFormGroup extends Vue {
  @Prop({default: null})
  model!: PayoutWebModel

  @Prop({default: 'amount'})
  attribute!: string

  @Prop({default: 'amount'})
  errorsAttribute!: string

  @Prop({default: false})
  disabled!: boolean

  @Prop({default: null})
  hint: string | null

  @Prop({default: (value: string) => value})
  filter?: (value: string) => string

  reverseFeeRequest = {
    id: 0,
    dirty: true,
    account: null,
  }

  get sourceAccount() {
    return this.model.getSourceAccount();
  }

  get modelFeeRule(): PayoutTaxRuleInterface | null {
    return ('taxRule' in this.model.options)
    && this.model.options.taxRule ? this.model.options.taxRule as PayoutTaxRuleInterface : null;
  }

  get modelHasFeeRule(): boolean {
    return Boolean(this.modelFeeRule);
  }

  updateValue(value: any) {
    this.$emit('input', value);
    this.model.values.amount = value;
  }

  onAvailBalanceClick($event?: any) {
    this.evaluateReverseFee();
  }

  evaluateReverseFee() {
    if (this.reverseFeeRequest.account
      && (this.reverseFeeRequest.account == this.model.values.fromAccount)) return;

    const requestId = ++this.reverseFeeRequest.id;

    this.reverseFeeRequest.account = this.model.values.fromAccount;
    this.model.errors.clear();

    this.updateValue('');

    this.model.evaluateReverseFee().then((result: EvaluateReverseFeeResultInterface) => {
      if (this.reverseFeeRequest.account == this.model.values.fromAccount) {
        if (requestId == this.reverseFeeRequest.id) {
          this.reverseFeeRequest.account = null;
          this.updateValue(result.amount ? String(result.amount) : '');
        }
      }
    }).catch(() => {});
  }
}
</script>

<style scoped lang="less">

</style>

<i18n>
{
  "en": {
    "Сумма": "Amount",
    "Всего": "Total",
    "Комиссия": "Commission"
  }
}
</i18n>
